<template>
  <div class="mobile-nav">
    <el-dropdown ref="dropdownRef" trigger="click" popper-append-to-body>
      <span class="el-dropdown-link">
        <img class="menuIcon" src="@/assets/menu.png" alt="">
      </span>

      <el-dropdown-menu slot="dropdown" class="mobile-nav-menu">
        <el-menu router unique-opened  @select="handleSelect">
          <el-menu-item index="/">首页</el-menu-item>

          <el-menu-item index="">
            <template #title>
              <a target="_blank" href="https://www.jxvtc.edu.cn/xxzl/xxjj.htm">学校概括</a>
            </template>
          </el-menu-item>

          <el-menu-item index="/newsList?type=news&name=新闻公告">新闻公告</el-menu-item>

          <el-submenu index="edu">
            <template slot="title">
              <span>双创教育</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="item in eduList" :key="item.dictCode" :index="`/newsList?typeCode=${item.dictCode}&name=${item.dictLabel}`">{{ item.dictLabel }} </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="space">
            <template slot="title">
              <span>创业空间</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="item in spaceList" :key="item.dictCode" :index="`/newsList?typeCode=${item.dictCode}&name=${item.dictLabel}`">{{ item.dictLabel }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="servers">
            <template slot="title">
               <span>资源服务</span>
            </template>
            <el-menu-item-group>
              <el-menu-item>
                <a target="_blank" href="https://jxvtcedu.woczx.com/#/college/login">双创资源</a>
              </el-menu-item>
              <el-menu-item>
                <a target="_blank" href="https://iqnrx.xetlk.com/s/25gGMw">职规资源</a>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="/newsDetail?id=1587040366502457345">下载中心</el-menu-item>
        </el-menu>
      </el-dropdown-menu>
    </el-dropdown>

  </div>
</template>

<script>
export default {
  name: 'MobileNav',
  props: ['edu', 'space'],
  data () {
    return {
      eduList: [],
      spaceList: []
    }
  },
  watch: {
    edu (n, o) {
      this.eduList = n
    },
    space (n, o) {
      this.spaceList = n
    }
  },
  methods: {
    handleSelect () {
      this.$refs.dropdownRef.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  cursor: pointer;
  width: 1.25rem;
  height: 1.0625rem;

  .menuIcon {
    width: 100%;
    height: 100%;
  }
}
</style>
